<template>
  <div id="JtChartCard">
    <jt-doughnut-chart
      v-if="charType === 'D'"
      :data="doughnutData"
      centralTitle="Teste"
      centralTitleConst="TEMPORARY_STORAGE"
      :formatterVisualTextValue="convertValueInDuration"
      :shouldShowLegend="true"
      :shouldShowLabelParts="true"
      :shouldShowPercentageInLabelParts="true"
      :shouldShowTotalInTheMiddle="true"
      :shouldShowValueInLabelParts="true"
    />
    <jt-card-gauge-chart
      v-if="charType === 'G'"
      cardTitle="Teste"
      :fontSize="20"
      :textFormattingType="3"
      :decimalPlaces="0"
      nmInterfaceForData="vehicle.hql"
      nmInterfaceGridForData="activateVehicles"
      nmInterfaceForTargetValue="vehicle.hql"
      nmInterfaceGridForTargetValue="totalVehicles"
    />
    <jt-bar-chart
      v-else-if="charType === 'B'"
      :data="barSettings.barData"
      :xAxisData="barSettings.columns"
      :shouldShowOverlappingBars="true"
      :shouldTranslateXAxisData="true"
      xAxisName="Teste Legal"
      yAxisNameConst="RESIDUE"
    />
    <jt-line-chart
      v-else-if="charType === 'L'"
      :data="lineSettings.lineData"
      :xAxisData="lineSettings.columns"
      :shouldShowOverlappingBars="true"
      :shouldTranslateXAxisData="true"
      xAxisName="Teste Legal"
      yAxisNameConst="RESIDUE"
    />
  </div>
</template>

<script>
import JtBarChart from '../../../charts/JtBarChart.vue'
import { Component, Vue } from 'vue-property-decorator'
import JtDoughnutChart from '../../../charts/JtDoughnutChart.vue'
import JtLineChart from 'src/components/charts/JtLineChart.vue'
import JtCardGaugeChart from './chart-type/JtCardGaugeChart.vue'
import { formatCurrency } from 'src/shared/utils/formatUtils'

@Component({
  name: 'JtChartCard',
  components: {
    JtBarChart,
    JtDoughnutChart,
    JtLineChart,
    JtCardGaugeChart
  },
  props: {
    charType: {
      type: String,
      required: true
    }
  }
})
export default class JtChartCard extends Vue {
  barSettings = {
    columns: [],
    barData: []
  }

  lineSettings = {
    columns: [],
    lineData: []
  }

  doughnutData = []
  gaugeData = [
    {
      label: 'Hahahaha',
      color: 'pink'
    },
    {
      labelConst: 'JAN',
      value: 5689,
      color: 'green'
    }
  ]

  shouldFormatAsCurrency = true

  convertValueInDuration (val) {
    if (this.shouldFormatAsCurrency) {
      const hours = Math.floor(val / 60)
      const mins = val - (hours * 60)
      return (hours > 0 ? `${hours}h` : '') + `${mins || 0}min`
    } else {
      return formatCurrency(val)
    }
  }

  mounted () {
    if (this.charType === 'B') this.initBarData()
    if (this.charType === 'D') this.initDoughnutData()
    if (this.charType === 'L') this.initLineData()
  }

  initLineData () {
    this.lineSettings.columns = ['RESIDUE', 'Aterro Y', '2014', '2015', 'Outra divisão', 'Mais uma divisão', 'Mais uma']
    this.lineSettings.lineData = [
      {
        label: 'Lixo Hospitalar',
        color: 'pink',
        data: [320, 332, 301, 334, 390]
      },
      {
        labelConst: 'RESIDUE',
        data: [200, 182, 191, 234, 290]
      },
      {
        color: 'red',
        data: [150, 232, 201, 154, 190, 98]
      }
    ]

    setTimeout(() => {
      this.lineSettings.columns = ['TESTE']
      setTimeout(() => {
        this.lineSettings.lineData[2].data = [12, 14, 15]
        setTimeout(() => {
          this.lineSettings.columns = ['RESIDUE', 'Aterro Y', '2014', '2015', 'Outra divisão', 'Mais uma divisão', 'Mais uma']
          setTimeout(() => {
            this.lineSettings.lineData[0].data = [69]
            this.lineSettings.lineData[1].data = [12, 14]
            this.lineSettings.lineData[2].data = [85, 58, 15, 98, 67, 54, 150]
            setTimeout(() => {
              this.lineSettings.lineData.push({
                label: 'NOVO CARINHA',
                data: [100, 50, 150, 125, 200, 175]
              })
              setTimeout(() => {
                this.lineSettings.columns = ['2014', '2015', '2016', '2017']
                setTimeout(() => {
                  this.lineSettings.lineData = [
                    {
                      label: 'Abacaxi',
                      color: 'pink',
                      data: [10, 50, 25, 80, 6]
                    }
                  ]
                }, 2000)
              }, 2000)
            }, 2000)
          }, 2000)
        }, 2000)
      }, 2000)
    }, 2000)
  }

  initDoughnutData () {
    this.doughnutData = [
      {
        label: 'Tempo vendo TV',
        value: 120
      },
      {
        labelConst: 'WAITING',
        value: 50
      },
      {},
      {
        value: undefined
      },
      {
        label: 'Teste sem Value'
      },
      {
        label: 'Teste de Cor',
        color: 'pink',
        value: 50
      }
    ]

    setTimeout(() => {
      this.doughnutData.push({
        labelConst: 'WASTE',
        color: 'red',
        value: 250
      })
      setTimeout(() => {
        this.doughnutData.splice(2, 3)
        setTimeout(() => {
          this.doughnutData.shift()
          setTimeout(() => {
            this.doughnutData.pop()
            setTimeout(() => {
              this.doughnutData.shift()
              setTimeout(() => {
                this.doughnutData.pop()
                setTimeout(() => {
                  this.shouldFormatAsCurrency = false
                  this.doughnutData = [{
                    label: 'Aaaaa',
                    value: 100
                  },
                  {
                    label: 'Bbbbb',
                    value: 50
                  },
                  {
                    label: 'Ccccc',
                    value: 200
                  },
                  {
                    label: 'Ddddd',
                    value: 150
                  },
                  {
                    label: 'Eeeee',
                    value: 300
                  }
                  ]
                }, 2000)
              }, 2000)
            }, 2000)
          }, 2000)
        }, 2000)
      }, 2000)
    }, 2000)
  }

  initBarData () {
    this.barSettings.columns = ['RESIDUE', 'Aterro Y', '2014', '2015', 'Outra divisão', 'Mais uma divisão', 'Mais uma']
    this.barSettings.barData = [
      {
        label: 'Lixo Hospitalar',
        color: 'pink',
        data: [320, 332, 301, 334, 390]
      },
      {
        labelConst: 'RESIDUE',
        data: [200, 182, 191, 234, 290]
      },
      {
        color: '#008000',
        data: [150, 232, 201, 154, 190, 98]
      }
    ]

    setTimeout(() => {
      this.barSettings.columns = ['TESTE']
      setTimeout(() => {
        this.barSettings.barData[2].data = [12, 14, 15]
        setTimeout(() => {
          this.barSettings.columns = ['RESIDUE', 'Aterro Y', '2014', '2015', 'Outra divisão', 'Mais uma divisão', 'Mais uma']
          setTimeout(() => {
            this.barSettings.barData[0].data = [69]
            this.barSettings.barData[1].data = [12, 14]
            this.barSettings.barData[2].data = [85, 58, 15, 98, 67, 54, 150]
            setTimeout(() => {
              this.barSettings.barData.push({
                label: 'NOVO CARINHA',
                data: [100, 50, 150, 125, 200, 175]
              })
              setTimeout(() => {
                this.barSettings.columns = ['2014', '2015', '2016', '2017']
                setTimeout(() => {
                  this.barSettings.barData = [
                    {
                      label: 'Abacaxi',
                      color: 'pink',
                      data: [10, 50, 25, 80, 6]
                    }
                  ]
                }, 2000)
              }, 2000)
            }, 2000)
          }, 2000)
        }, 2000)
      }, 2000)
    }, 2000)
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

#JtChartCard {
  width: 100%;
  height: 100%;
}
</style>
